/**
 * Fime – Markets Carousel
 *
 * Embla is only active below the md breakpoint (768px). Above it, the
 * .markets-grid element is a plain CSS grid (see main.css) and this
 * module leaves it completely untouched. On resize across the
 * breakpoint, Embla is initialized/destroyed accordingly so the layout
 * always matches its current CSS state.
 *
 * No autoplay — this is informational content, not a promo carousel.
 */

import EmblaCarousel from 'embla-carousel';

const BREAKPOINT = '(max-width: 767px)';

function initMarketsCarousel() {
	const viewport = document.querySelector('[data-markets-viewport]');
	const prevBtn = document.querySelector('[data-markets-prev]');
	const nextBtn = document.querySelector('[data-markets-next]');

	if (!viewport) return null;

	const emblaApi = EmblaCarousel(viewport, {
		align: 'start',
		containScroll: 'trimSnaps',
		dragFree: false,
	});

	function updateButtons() {
		if (prevBtn) prevBtn.disabled = !emblaApi.canScrollPrev();
		if (nextBtn) nextBtn.disabled = !emblaApi.canScrollNext();
	}

	const onPrevClick = () => emblaApi.scrollPrev();
	const onNextClick = () => emblaApi.scrollNext();

	prevBtn && prevBtn.addEventListener('click', onPrevClick);
	nextBtn && nextBtn.addEventListener('click', onNextClick);

	emblaApi.on('select', updateButtons);
	emblaApi.on('reInit', updateButtons);
	updateButtons();

	return function destroy() {
		prevBtn && prevBtn.removeEventListener('click', onPrevClick);
		nextBtn && nextBtn.removeEventListener('click', onNextClick);
		emblaApi.destroy();
	};
}

document.addEventListener('DOMContentLoaded', () => {
	const mql = window.matchMedia(BREAKPOINT);
	let destroy = null;

	function sync() {
		if (mql.matches && !destroy) {
			destroy = initMarketsCarousel();
		} else if (!mql.matches && destroy) {
			destroy();
			destroy = null;
		}
	}

	sync();
	mql.addEventListener('change', sync);
});
